import { useState, useEffect } from "react";
import LoadingSpinner from "../shared-components/LoadingSpinner";
import CopyIcon from "../shared-components/CopyIcon";
import { formattedDate } from "../utils";
import { SelfServeReport } from "../api/SelfServe";
import { getReportStatusDisplayName } from "../api/Reports";

interface TableProps {
  data: SelfServeReport[] | undefined;
  header: Array<{ name: string }>;
  isLoading: boolean;
  onEventComplete: () => void;
}

const Table = ({ data, header, isLoading, onEventComplete }: TableProps) => {
  const [tableData, setTableData] = useState<SelfServeReport[]>([]);
  useEffect(() => {
    if (data) setTableData(data);
  }, [data]);

  // Helper method to display value or dash if it doesn't exist
  const displayValueOrDash = (
    value: string | undefined | null,
    capitalize = false
  ): string => {
    if (!value || value.trim() === "") {
      return "-";
    }
    return capitalize ? value.charAt(0).toUpperCase() + value.slice(1) : value;
  };

  return (
    <>
      <div>
        <div className="flex text-gray-500 rounded-t-xl border shadow shadow-gray-300">
          {header.map((header) => (
            <div
              className="flex rounded-t-xl p-3 text-xs text-left leading-4 font-medium bg-gray-50 uppercase flex-1"
              key={header.name}
            >
              {header.name}
            </div>
          ))}
        </div>
        <div className="bg-white border-l border-r rounded-b-xl shadow shadow-gray-300">
          {isLoading ? <LoadingSpinner /> : ""}
          {tableData.length === 0 && !isLoading ? (
            <div className="flex justify-center p-4 ">
              No Consent Forms found
            </div>
          ) : (
            tableData.map(
              (
                {
                  name,
                  external_id,
                  content: { custom_id, consent_status },
                  status,
                  created_at,
                  finished_at,
                  content: { payment_token },
                },
                i
              ) => (
                <div key={`self-serve-${i}`}>
                  <div className="flex border-b text-xs leading-4 font-normal py-4 hover:bg-gray-50">
                    <div className="flex px-3 flex-1  items-center font-semibold truncate text-ellipsis w-32 underline">
                      {name}
                    </div>
                    <div className="flex px-3 flex-1 truncate  items-center text-ellipsis w-32">
                      {displayValueOrDash(custom_id)}
                    </div>
                    <div className="flex px-3 flex-1 truncate  items-center text-ellipsis w-32">
                      <div className="flex text-left flex-col">
                        <span className="text-xs text-gray-500">
                          Report Status: {getReportStatusDisplayName(status)}
                        </span>
                        <span className="text-xs text-gray-500">
                          Consent Status:{" "}
                          {displayValueOrDash(consent_status, true)}
                        </span>
                      </div>
                    </div>
                    <div className="flex px-3 flex-1 truncate  items-center text-ellipsis w-32">
                      {created_at && formattedDate(created_at)}
                    </div>
                    <div className="flex px-3 flex-1 truncate  items-center text-ellipsis w-32">
                      {finished_at && formattedDate(finished_at)}
                    </div>
                    <div className="flex px-3 flex-1 truncate  items-center text-ellipsis w-32">
                      {displayValueOrDash(payment_token)}
                    </div>
                    <div className="flex px-3 flex-1 truncate  items-center text-ellipsis w-32">
                      <CopyIcon textToCopy={external_id}></CopyIcon>
                      {displayValueOrDash(external_id)}
                    </div>
                  </div>
                </div>
              )
            )
          )}
        </div>
      </div>
    </>
  );
};

export default Table;
